import { render, staticRenderFns } from "./MedicalCheckPage.vue?vue&type=template&id=2948e1b4&scoped=true&"
import script from "./MedicalCheckPage.vue?vue&type=script&lang=js&"
export * from "./MedicalCheckPage.vue?vue&type=script&lang=js&"
import style0 from "./MedicalCheckPage.vue?vue&type=style&index=0&id=2948e1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948e1b4",
  null
  
)

export default component.exports